((Drupal) => {
  Drupal.behaviors.closeModal = {
    attach: function (context, settings) {
      once('close-modal', '[data-action="close-modal"]', context).forEach(function(button) {
        button.addEventListener('click', function() {
          var modal = this.closest('.status-message');
          if (modal) {
            modal.style.display = 'none';
          }
        });
      });
    }
  };
})(Drupal);
